import { excelDownloadId } from "@/assets/googleTrackIds";
import { FC } from "react";
import { transactionApis } from "@payping/api";
import { Button, useMessagedAsyncFn } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { downloadBlob } from "@/utils/download-blob";

type props = {
  loading: boolean;
  filters: string;
};
const TransactionDownloadList: FC<props> = ({ loading, filters }) => {
  const { t } = useAppTranslation();

  const [downloadState, download] = useMessagedAsyncFn(async () => {
    const res = await (await transactionApis.getTransactionsExcelWithFilterWithCancellationTokenGet(filters)).blob();
    const file = new File([res], "transactions.xlsx");
    downloadBlob(file, file.name);
    return res;
  }, []);

  return (
    <Button
      block
      disabled={loading}
      loading={downloadState.loading}
      onClick={download}
      data-google-track={excelDownloadId}
    >
      {t("downloadExcel")}
    </Button>
  );
};

export default TransactionDownloadList;
